import React from "react";
import { DOCTOR } from "@/lib/content";
import { Award, GraduationCap, Sparkles, ArrowRight } from "lucide-react";

export default function Doctors({ onBook }) {
    return (
        <section
            id="doctors"
            data-testid="doctors-section"
            className="py-24 md:py-32 bg-[#f3f0ea]"
        >
            <div className="mx-auto max-w-7xl px-6 md:px-12">
                <div className="max-w-2xl mb-14">
                    <div className="text-xs uppercase tracking-[0.3em] text-[#7a8582] flex items-center">
                        <span className="gdc-divider" />
                        Meet the doctor
                    </div>
                    <h2 className="font-serif-display mt-4 text-4xl md:text-5xl leading-tight text-[#1a1d1c]">
                        The specialist behind
                        <br />
                        <span className="italic text-[#114b5f]">
                            every Galaxy smile.
                        </span>
                    </h2>
                </div>

                <div
                    data-testid="doctor-feature"
                    className="grid grid-cols-1 lg:grid-cols-12 gap-10 items-center"
                >
                    <div className="lg:col-span-4">
                        <div className="relative max-w-[380px] mx-auto lg:mx-0">
                            <div className="absolute -inset-3 bg-[#114b5f]/10 rounded-3xl blur-2xl" />
                            <img
                                src={DOCTOR.portrait}
                                alt={DOCTOR.name}
                                className="relative w-full aspect-[4/5] object-cover object-[center_15%] rounded-t-[4rem] rounded-b-3xl ring-1 ring-black/5 shadow-xl"
                            />
                            <div className="absolute -bottom-5 left-5 bg-[#114b5f] text-[#faf9f6] rounded-2xl px-4 py-2.5 shadow-xl">
                                <div className="text-[9px] uppercase tracking-[0.28em] text-[#d4af37]">
                                    Prosthodontist
                                </div>
                                <div className="font-serif-display text-base mt-0.5">
                                    &amp; Implant Specialist
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="lg:col-span-8">
                        <h3 className="font-serif-display text-4xl md:text-5xl text-[#1a1d1c] leading-tight">
                            {DOCTOR.name}
                        </h3>
                        <p className="text-xs uppercase tracking-[0.25em] text-[#7a8582] mt-3">
                            {DOCTOR.credentials}
                        </p>

                        <div className="mt-8 space-y-5">
                            {DOCTOR.bio.map((p, i) => (
                                <p
                                    key={i}
                                    className="text-base md:text-lg text-[#4a5250] leading-relaxed"
                                >
                                    {p}
                                </p>
                            ))}
                        </div>

                        <div className="mt-10 grid grid-cols-1 sm:grid-cols-3 gap-4">
                            <div className="bg-white rounded-2xl p-5 border border-[#e8e4db]">
                                <GraduationCap
                                    size={20}
                                    strokeWidth={1.5}
                                    className="text-[#114b5f]"
                                />
                                <div className="mt-3 font-serif-display text-2xl text-[#114b5f]">
                                    {DOCTOR.years}
                                </div>
                                <div className="text-xs uppercase tracking-[0.2em] text-[#7a8582] mt-1">
                                    In practice
                                </div>
                            </div>
                            <div className="bg-white rounded-2xl p-5 border border-[#e8e4db]">
                                <Award
                                    size={20}
                                    strokeWidth={1.5}
                                    className="text-[#114b5f]"
                                />
                                <div className="mt-3 font-serif-display text-2xl text-[#114b5f]">
                                    {DOCTOR.implants}
                                </div>
                                <div className="text-xs uppercase tracking-[0.2em] text-[#7a8582] mt-1">
                                    Clinical record
                                </div>
                            </div>
                            <div className="bg-white rounded-2xl p-5 border border-[#e8e4db]">
                                <Sparkles
                                    size={20}
                                    strokeWidth={1.5}
                                    className="text-[#114b5f]"
                                />
                                <div className="mt-3 font-serif-display text-2xl text-[#114b5f]">
                                    Prostho­dontist
                                </div>
                                <div className="text-xs uppercase tracking-[0.2em] text-[#7a8582] mt-1">
                                    MDS specialty
                                </div>
                            </div>
                        </div>

                        <button
                            type="button"
                            onClick={() => onBook?.()}
                            data-testid="doctor-book-consultation"
                            className="mt-10 rounded-full bg-[#114b5f] text-[#faf9f6] px-8 py-4 text-sm font-medium hover:bg-[#0d3a4a] transition-all hover:shadow-lg inline-flex items-center gap-2"
                        >
                            Consult Dr. Swapnil
                            <ArrowRight size={16} strokeWidth={1.75} />
                        </button>
                    </div>
                </div>
            </div>
        </section>
    );
}
